const KT_SKL_CONTEXT_VALUE = 'key-transparency.key-list';

export const KT_SKL_SIGNING_CONTEXT = {
    value: KT_SKL_CONTEXT_VALUE,
    critical: false,
};

export const KT_SKL_VERIFICATION_CONTEXT = {
    value: KT_SKL_CONTEXT_VALUE,
    required: false,
};
